import * as martinez from 'martinez-polygon-clipping';

function arrayToRing(arr) {
    let parts = [],
        ret = '';

    for (let i = 0; i < arr.length; i++) {
        parts.push(arr[i].join(' '));
    }

    ret += '(' + parts.join(', ') + ')';

    return ret;
}

function polygonToWKTPolygon(primitive) {
    let ret = 'POLYGON ';
    const data = primitive.coordinates;
    if (!data) {
        ret += 'EMPTY';
        return ret;
    }
    ret += '(';
    const parts = [];
    for (let i = 0; i < data.length; i++) {
        const item = data[i];
        parts.push(arrayToRing(item));
    }
    ret += parts.join(', ');
    ret += ')';
    return ret;
}

function multiPolygonToWKTMultiPolygon(primitive) {
    let ret = 'MULTIPOLYGON ';
    if (!primitive.coordinates) {
        ret += 'EMPTY';
        return ret;
    }

    ret += '(';
    const inner = [];
    if (primitive.coordinates) {
        for (let c = 0; c < primitive.coordinates.length; c++) {
            let it = '(';
            const parts = [];
            const cItem = primitive.coordinates[c];
            for (let i = 0; i < cItem.length; i++) {
                const item = cItem[i];
                parts.push(arrayToRing(item));
            }
            it += parts.join(', ');
            it += ')';
            inner.push(it);
        }
    }
    ret += inner.join(', ');
    ret += ')';
    return ret;
}

const mapUtil = {
    getBounds: function(map) {
        let box = map.getViewModel().getLookAtData().bounds.getBoundingBox();
        return [box.getLeft(), box.getRight(), box.getBottom(), box.getTop()];
    },
    getFormatBounds: function(map) {
        var bounds = mapUtil.getBounds(map);
        return [
            {
                lng: bounds[0],
                lat: bounds[2]
            },
            {
                lng: bounds[1],
                lat: bounds[2]
            },
            {
                lng: bounds[1],
                lat: bounds[3]
            },
            {
                lng: bounds[0],
                lat: bounds[3]
            }
        ];
    },

    // whether the point is inside the quadrilateral 
    pointInbound: function(x, y, bounds) {
        return (
            x >= bounds[0] && x <= bounds[1] && y >= bounds[2] && y <= bounds[3]
        );
    },

    // Calculate the distance between two points 
    distance(p1, p2) {
        return Math.sqrt(
            Math.pow(p1.lat - p2.lat, 2) + Math.pow(p1.lng - p2.lng, 2)
        );
    },

    // Calculate the intersection point of two polygons  vs2 painting borders   vs1  borders of the map 
    intersectionPolygon(vs2, vs1) {
        var geom1 = mapUtil.pathToGeo(vs1),
            geom2 = mapUtil.pathToGeo(vs2);
        var coor = martinez.intersection(geom1.coordinates, geom2.coordinates);
        return mapUtil.geoToPath(coor[0]);
    },
    polygonToWKT(primitive) {
        const type = primitive.type || 'Polygon';
        if (type === 'MultiPolygon') {
            return multiPolygonToWKTMultiPolygon(primitive);
        } else {
            return polygonToWKTPolygon(primitive);
        }
    }
};

export default mapUtil;
